@if (anchor) {
  <a [id]="anchor"></a>
}

<a kb-standalone-link
  [kbRouterOrExternalLink]="attributes.link.attributes.url"
  [attr.target]="attributes.link.attributes.target"
  direction="back"
  [class.page-edge-gap]="!attributes.indentedLink"
  [appEditorId]="attributes.link.editorIds?.label"
>{{ attributes.link.attributes.label }}</a>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
